/* eslint-disable complexity */
// Copyright (c) 2016 Deere & Company

import './part-info-panel.scss';
import React, {PropTypes} from 'react';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import LabeledInput from '../../../claim/shared/components/claim-fields/labeled-input';
import LabeledKeyValueDropDown from '../../../claim/shared/components/claim-fields/labeled-key-value-dropdown';
import LabeledString from '../../../shared/components/labeled-string';
import RgaDetails from '../../rga-search-results/state/rga-details';
import Security from '@deere/cps-it.warranty-model-factory/lib/security';
import {buildDate} from '../../../shared/services/build-date';
import {findValueKeyPair} from '../../shared/services/rga-utils';
import {hasAccess} from '../../../shared/services/security';

function onChangeAnalysisFieldValue(propertyName, props, value) {

    props.actions.updateRgaAnalysisValues(propertyName, value);

}

function getStatusList(props) {

    if (props.rgaDetails.rgaSubType === 'PICT') {

        return props.photoReqStatus.filter(item => item.value !== '');

    } else if (props.rgaDetails.rgaSubType === 'INFO') {

        return props.infoReqStatus.filter(item => item.value !== '');

    } else if (props.rgaDetails.rgaSubType === 'PART') {

        return props.partReqStatus;

    }
    return [{key: '', value: ''}];

}

function onChangeAnalysisDropDownValue(propertyName, props, event) {

    const dropDownList = getStatusList(props);

    const selectedItem = dropDownList.find(item => item.key === event.target.value);
    const selectedKey = selectedItem ? selectedItem.key : '';

    props.actions.updateRgaAnalysisValues(propertyName, selectedKey);

}

const buildPartReturnString = partRequest => `${partRequest.partNumber} - ${partRequest.partDescription}`;

const PartInfoPanel = props =>
    <section className='part-info-panel'>
        <div className='part-header'>
            <span>{props.rgaDetails.rgaSubType} {props.rgaDetails.stripLeadingZerosForRgaNumber()}{''}</span>
        </div>
        <div className='part-info'>
            <div className='row'>
                <LabeledString
                    className='model'
                    data={buildPartReturnString(props.rgaDetails)}
                    label='Requested Part'
                />
                <LabeledString
                    className='days-rented'
                    data={props.rgaDetails.requestedPartQuantity}
                    label='Requested Quantity'
                />
            </div>
            <div className='row'>
                <LabeledString
                    className='base-machine'
                    data={props.rgaDetails.warrantyClaimNumber}
                    label='Warranty Claim'
                />
                <LabeledString
                    className='base-machine'
                    data={props.rgaDetails.requesterType}
                    label='Request Type'
                />
            </div>
            <div className='row'>
                <LabeledString
                    className='base-machine'
                    data={buildDate(props.rgaDetails.requestedDate)}
                    label='Request Date'
                />
                <LabeledString
                    className='base-machine'
                    data={buildDate(props.rgaDetails.followUpDate)}
                    label='FollowUp Date'
                />
            </div>
            <div className='row'>
                <LabeledString
                    className='part-request-input'
                    data={buildDate(props.rgaDetails.processedDate)}
                    label='Processed Date'
                />
                <LabeledString
                    className='base-machine'
                    data={props.rgaDetails.dtacCaseNumber}
                    label='DTAC Case Number'
                />
            </div>
            {props.queryParams && props.queryParams.tab === 'analyst' ? <hr/> : null}
            {props.security.role === 'RGA_USER' ?
                <div className='row'>
                    <LabeledString
                        className='model'
                        data={props.rgaDetails.machineSerialNumber}
                        label='Pin'
                    />
                    <LabeledString
                        className='model'
                        data={props.rgaDetails.model}
                        label='MODEL'
                    />
                </div> :
                <div className='row'>
                    {props.queryParams && props.queryParams.tab === 'analyst' ?
                        <LabeledInput
                            className='part-request-input'
                            isEditable={true}
                            label='Pin'
                            onChange={onChangeAnalysisFieldValue.bind(event, 'machineSerialNumber', props)}
                            value={props.rgaDetails.machineSerialNumber}
                        /> :
                            <LabeledString
                                className='model'
                                data={props.rgaDetails.machineSerialNumber}
                                label='Pin'
                            />}
                    {props.queryParams && props.queryParams.tab === 'analyst' ?
                        <LabeledInput
                            className='part-request-input'
                            isEditable={true}
                            label='MODEL'
                            onChange={onChangeAnalysisFieldValue.bind(event, 'model', props)}
                            value={props.rgaDetails.model}
                        /> :
                            <LabeledString
                                className='model'
                                data={props.rgaDetails.model}
                                label='MODEL'
                            />}
                </div>}
            {props.security.role === 'RGA_USER' ?
                <div className='row'>
                    <LabeledString
                        className='model'
                        data={props.rgaDetails.engineSerialNumber}
                        label='Engine Serial Number'
                    />
                    <LabeledString
                        className='model'
                        data={props.rgaDetails.componentSerialNumber}
                        label='Component Serial Number'
                    />
                </div> :
                <div className='row'>
                    {props.queryParams && props.queryParams.tab === 'analyst' ?
                        <LabeledInput
                            className='part-request-input'
                            isEditable={true}
                            label='Engine Serial Number'
                            onChange={onChangeAnalysisFieldValue.bind(event, 'engineSerialNumber', props)}
                            value={props.rgaDetails.engineSerialNumber}
                        /> : <LabeledString
                            className='model'
                            data={props.rgaDetails.engineSerialNumber}
                            label='Engine Serial Number'
                             /> }
                    {props.queryParams && props.queryParams.tab === 'analyst' ?
                        <LabeledInput
                            className='part-request-input'
                            isEditable={true}
                            label='Component Serial Number'
                            onChange={onChangeAnalysisFieldValue.bind(event, 'componentSerialNumber', props)}
                            value={props.rgaDetails.componentSerialNumber}
                        /> :
                            <LabeledString
                                className='model'
                                data={props.rgaDetails.componentSerialNumber}
                                label='Component Serial Number'
                            />}
                </div>}
            {props.security.role === 'RGA_USER' ?
                <div className='row'>
                    <LabeledString
                        className='model'
                        data={props.rgaDetails.machineHours}
                        label='HOURS'
                    />
                    <LabeledString
                        className='model'
                        data={props.rgaDetails.engineHours}
                        label='Engine Hours'
                    />
                </div> :
                <div className='row'>
                    {props.queryParams && props.queryParams.tab === 'analyst' ?
                        <LabeledInput
                            className='part-request-input'
                            isEditable={true}
                            label='HOURS'
                            onChange={onChangeAnalysisFieldValue.bind(event, 'machineHours', props)}
                            value={props.rgaDetails.machineHours}
                        /> :
                            <LabeledString
                                className='model'
                                data={props.rgaDetails.machineHours}
                                label='HOURS'
                            />}
                    {props.queryParams && props.queryParams.tab === 'analyst' ?
                        <LabeledInput
                            className='part-request-input'
                            isEditable={true}
                            label='Engine Hours'
                            onChange={onChangeAnalysisFieldValue.bind(event, 'engineHours', props)}
                            value={props.rgaDetails.engineHours}
                        /> :
                            <LabeledString
                                className='model'
                                data={props.rgaDetails.engineHours}
                                label='Engine Hours'
                            />}
                </div>}
            {props.security.role === 'RGA_USER' ?
                <div className='row'>
                    <LabeledString
                        className='model'
                        data={findValueKeyPair(getStatusList(props), props.rgaDetails.rgaRecallStatus).value}
                        label={`${props.rgaDetails.rgaSubType.toLowerCase()} Request Status`}
                    />
                </div> :
                <div className='row'>
                    {(!hasAccess(props.security, 'RECALLED_PARTS', 'RECALLED_PARTS_ADMIN') && hasAccess(props.security, 'RECALLED_PARTS', 'RECALLED_PARTS_EDIT')) || (props.queryParams && props.queryParams.tab !== 'analyst') ?

                        <LabeledString
                            className='model'
                            data={findValueKeyPair(getStatusList(props), props.rgaDetails.rgaRecallStatus).value}
                            label={`${props.rgaDetails.rgaSubType.toLowerCase()} Request Status`}
                        /> : <LabeledKeyValueDropDown
                            className={'part-request-input'}
                            isEditable={true}
                            isValid={true}
                            label={`${props.rgaDetails.rgaSubType.toLowerCase()} Request Status`}
                            list={getStatusList(props)}
                            onChange={onChangeAnalysisDropDownValue.bind(event, 'rgaRecallStatus', props)}
                            selectedValue={findValueKeyPair(getStatusList(props), props.rgaDetails.rgaRecallStatus)}
                             />}
                </div>}
        </div>
    </section>;

PartInfoPanel.displayName = 'PartInfoPanel';
PartInfoPanel.propTypes = {
    actions: PropTypes.object.isRequired,
    infoReqStatus: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    partReqStatus: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    photoReqStatus: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    queryParams: PropTypes.object.isRequired,
    rgaDetails: PropTypes.instanceOf(RgaDetails).isRequired,
    security: PropTypes.instanceOf(Security).isRequired
};

export default PartInfoPanel;



// WEBPACK FOOTER //
// ./src/rga/shared/components/Part-Info-Panel.js